import React, { Component } from "react";

import Header from "parts/Header";
import Footer from "parts/Footer";
import DiscussForm from "parts/DiscussForm";

import { Helmet } from "react-helmet-async";

export default class ContactPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>
            Contact | Custom Software, website & App Development | Scode
            Software Solutions
          </title>
          <meta
            name="description"
            content="Contact Us We’re Just a Form Away – Let’s Connect!"
          />
          <link
            rel="canonical"
            href="https://www.scodesoft.com/discuss-project"
          />
        </Helmet>

        <Header />
        <DiscussForm />
        <Footer />
      </>
    );
  }
}
